// extracted by mini-css-extract-plugin
export default {"ctn":"columnLayout_ctn__S0iNz","reverse":"columnLayout_reverse__VVUcX"};